import React, { CSSProperties, useState } from 'react';
import { getWindow } from 'src/utilities/window';

interface CreateSelectedItemsMapProps<T> {
  selectedItems: (Partial<T> | T)[];
  keyName: keyof T;
  useSearchToInitalizeSelectedItems: boolean;
  selectedItemsIdMap: React.MutableRefObject<{
    [id: string]: boolean;
  }>;
}

export const useKeyPress = (targetKey: string): boolean => {
  const window = getWindow();
  const [keyPressed, setKeyPressed] = useState(false);

  function downHandler({ key }) {
    if (key === targetKey) {
      setKeyPressed(true);
    }
  }

  const upHandler = ({ key }) => {
    if (key === targetKey) {
      setKeyPressed(false);
    }
  };

  React.useEffect(() => {
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);

    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  });

  return keyPressed;
};

export function getInitValue<T>(val: T | T[]): T[] {
  if (!val) {
    return [];
  }

  return Array.isArray(val) ? val : [val];
}

export function createSelectedItemsMap<T>({
  keyName,
  useSearchToInitalizeSelectedItems,
  selectedItemsIdMap,
  selectedItems,
}: CreateSelectedItemsMapProps<T>): void {
  if (useSearchToInitalizeSelectedItems && selectedItems.length > 0) {
    const selectedItemIds = selectedItems.reduce((mapping, item) => {
      const itemKeyValue = item[keyName] as unknown as string;
      // eslint-disable-next-line no-param-reassign
      mapping[itemKeyValue] = true;

      return mapping;
    }, {});

    // eslint-disable-next-line no-param-reassign
    selectedItemsIdMap.current = selectedItemIds;
  }
}

const DROPDOWN_GAP_PX = 8;

export function getSearchMenuStyles(
  dropdownContainerRef: React.RefObject<HTMLDivElement>
): CSSProperties {
  const rect = dropdownContainerRef.current?.getBoundingClientRect();

  if (!rect) {
    return {};
  }

  return {
    top: rect.bottom + DROPDOWN_GAP_PX,
    left: rect.left,
    width: rect.width,
  };
}
